const { jQuery: $ } = window;
import Utils from "./utils.class";

export default class Accordion {
    #$locAccordion;
    #utils;

    constructor(utils) {
        this.#utils = utils;
        Utils.log("Slider Initialized");


    }

    // run() {
    //     function close_section() {
    //         $('.accordion .section-title').removeClass('active');
    //         $('.accordion .section-content').removeClass('open').slideUp(350);
    //     }
    //
    //     $('.section-title').click(function(e) {
    //         // Get current link value
    //         let currentLink = $(this).attr('href');
    //         if($(e.target).is('.active')) {
    //             close_section();
    //         }else {
    //             close_section();
    //             // Add active class to section title
    //             $(this).addClass('active');
    //             // Display the hidden content
    //             $('.accordion ' + currentLink).slideDown(350).addClass('open');
    //         }
    //         e.preventDefault();
    //     });
    //
    // };
    run() {
        $('.section-title').click(function(e) {
            const $accordion = $(this).parents('.section'); // get the parent element (single accordion)
            const $module = $accordion.parents(".accordion"); // get current module
            const isActive = $(this).hasClass('active');

            $module.find('.section-title').removeClass('active'); // find all titles, remove all active classes
            $module.find('.section-content').removeClass('open').slideUp(350); // find all content, close open ones
            if (!isActive) {
                $accordion.find('.section-title').addClass('active'); // add active class to current title (we could use $(this) instead of $accordion.find('.section-title') - I wrote it this way for consistency)
                $accordion.find('.section-content').slideDown(350).addClass('open'); // add open class and animate opening on current content
                e.preventDefault(); // this isn't necessary usually unless you are clicking on an A tag, and there's no need for one here
            }
        });
    };
}